import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectVerifiableDevices } from 'selectors/devices';
import StatusTable from '../StatusTable';

const SiteVerification = ({ siteId }) => {
    const selectedDevices = useMemo(() => selectVerifiableDevices(siteId), [siteId]);
    const devices = useSelector(selectedDevices);

    return <StatusTable devices={devices} showWiseBox/>;
};

export default SiteVerification;
